import React, {useState} from 'react';
import AutosizeInput from 'react-input-autosize';

import './input-submit.scss'

function InputSubmit(props) {
    const {value, onSubmit} = props;
    const [val, setVal] = useState(value);

    return <AutosizeInput
        autoFocus={true}
        className={'autosize-input-submit btn-link'}
        value={val}
        onBlur={() => onSubmit(val)}
        onChange={(e) => setVal(e.target.value)}
    />
}

export default InputSubmit